import { Component, DestroyRef, DOCUMENT, OnInit, inject } from '@angular/core';
import { ROLES } from 'src/app/core/modules/sistema/enums/roles.enum';
import { IMenu } from 'src/app/core/modules/sistema/models/IMenu.interface';
import { SeguridadService } from 'src/app/core/modules/sistema/services/seguridad/seguridad.service';

import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  standalone: false,
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  private readonly router = inject(Router)
  private readonly document = inject(DOCUMENT)
  private readonly destroyRef = inject(DestroyRef)
  private _seguridadService = inject(SeguridadService);

  public logoCuenta: string | undefined;
  public cuentaId: number = 0;
  public esAdministrador: boolean = false;
  public nombreUsuario: string = '';
   public menus: Array<IMenu> = [];

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if ((this.document.defaultView?.innerWidth ?? 1200) < 1200) this.document.body.classList.remove('toggle-sidebar')
    })
    if (!this._seguridadService.esSesionActiva()) {
      return;
    }

    this.cuentaId = this._seguridadService.obtenerCuenta();
    const logos: Record<number, string> = { 5: 'img/clientes/5.png', 6: 'img/clientes/6.jpg' };
    this.logoCuenta = logos[this.cuentaId];
    this.esAdministrador = this._seguridadService.obtenerRol() === ROLES.Administrador;
    this.nombreUsuario = this._seguridadService.obtenerNombreUsuario();
    this.menus = this._seguridadService.Menus;
  }

  public obtenerTituloModulo(nombre: string): string {
    return nombre.replace(/\s/g, "");
  }  
}
